/**
 * Converts SVG URLs to base64 data URIs for safe display in <img> tags
 * @param url The image URL to process
 * @returns A safe image source to use in <img> tags
 */
export const getSafeImageSrc = async (url: string | undefined | null): Promise<string> => {
  if (!url) return '';
  
  // Only process SVG files
  if (url.toLowerCase().endsWith('.svg')) {
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`Failed to fetch SVG: ${response.status} ${response.statusText}`);
      }
      
      const svgText = await response.text();
      const base64 = btoa(unescape(encodeURIComponent(svgText)));
      return `data:image/svg+xml;base64,${base64}`;
    } catch (error) {
      console.error('Error converting SVG to base64:', error);
      return url; // Return original URL if conversion fails
    }
  }
  
  // Return original URL for non-SVG files
  return url;
};